import type { BasketResponse, PaymentMethod } from "@onestore/api/basket"
import type { Term } from "@onestore/api/types"
import type { HTTP } from "@onestore/onestore-store-common"
import { HTTP_STATUS } from "@onestore/onestore-store-common/http"
import type {
  ResponseStatusAction,
  SimpleAction,
} from "~/store/checkout/actions"
import type { CheckoutActions } from "~/store/checkout/constants"
import { CheckoutTermsActionType } from "~/store/checkout-terms/constants"
import type { PaymentSuccessAction } from "~/store/order/actions"
import type { AppDispatch } from "~/store/reducer"

type TermsValidationAction = {
  type: CheckoutTermsActionType.TERMS_VALIDATION
  value: boolean | undefined
}

type TermsAddTermTabRequiredIdAction = {
  type: CheckoutTermsActionType.TERMS_ADD_TERM_TAB_REQUIRED_ID
  termTabRequiredId: number | undefined
}

type ActiveTermTabIdAction = {
  type: CheckoutTermsActionType.TERMS_ACTIVE_TERM_TAB_ID
  activeTermTabId: number
}

type BasketTermsSuccessAction = {
  type: CheckoutTermsActionType.TERMS_SUCCESS
  response_status_code: HTTP.Status
  result: Term[]
  payment_method: number | null
  payment_methods: PaymentMethod[]
}

type BasketToggleTermsAction = {
  type: CheckoutTermsActionType.TERMS_TOGGLE_TERMS
  terms: {
    type: Term["type"]
    id: Term["id"]
  }[]
}

export type CheckoutTermsAction =
  | TermsValidationAction
  | PaymentSuccessAction
  | BasketToggleTermsAction
  | BasketTermsSuccessAction
  | SimpleAction<CheckoutTermsActionType.TERMS_TOGGLE_ALL_TERMS>
  | SimpleAction<CheckoutTermsActionType.TERMS_PENDING>
  | ResponseStatusAction<CheckoutTermsActionType.TERMS_FAILURE>
  | ResponseStatusAction<CheckoutTermsActionType.TERMS_PENDING>
  | ResponseStatusAction<CheckoutActions.CHECKOUT_RESET>
  | TermsAddTermTabRequiredIdAction
  | ActiveTermTabIdAction

export function toggleTerms(terms: BasketToggleTermsAction["terms"]) {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: CheckoutTermsActionType.TERMS_TOGGLE_TERMS,
      terms,
    })
  }
}

export function setTermTabRequiredId(termTabRequiredId?: number) {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: CheckoutTermsActionType.TERMS_ADD_TERM_TAB_REQUIRED_ID,
      termTabRequiredId,
    })
  }
}

export function setActiveTermTabId(activeTermTabId: number) {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: CheckoutTermsActionType.TERMS_ACTIVE_TERM_TAB_ID,
      activeTermTabId,
    })
  }
}

export function toggleAllTerms() {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: CheckoutTermsActionType.TERMS_TOGGLE_ALL_TERMS,
    })
  }
}

export function termsSuccessActionCreator(
  result: BasketResponse
): BasketTermsSuccessAction {
  const mappedResult = result.terms.map(
    (term): Term => ({
      ...term,
      checked: [term.checked, term.checked],
    })
  )

  return {
    type: CheckoutTermsActionType.TERMS_SUCCESS,
    response_status_code: HTTP_STATUS.OK,
    result: mappedResult,
    payment_methods: result.payment_methods,
    payment_method: result.payment_method,
  }
}
